import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonPurpose } from './button-purpose';
import { ButtonType } from './button-type';
import * as i0 from "@angular/core";
export class MheButtonComponent {
    _checked = null;
    ariaExpanded = null;
    get btnClasses() {
        return [
            'btn',
            'ngx-shared',
            this.purpose,
            this.enableLight ? 'btn-secondary-light' : '',
            this._checked ? 'active' : '',
            this.class,
        ]
            .filter(Boolean)
            .join(' ');
    }
    _role = null;
    type = ButtonType.Button;
    class = '';
    enableLight = false;
    purpose = ButtonPurpose.Primary;
    set checked(value) {
        this._checked = value;
        if (typeof value === 'boolean') {
            this._role = 'switch';
        }
        else {
            this._role = null;
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MheButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: MheButtonComponent, selector: "button[mhe-button]", inputs: { ariaExpanded: "ariaExpanded", type: "type", class: "class", enableLight: "enableLight", purpose: "purpose", checked: "checked" }, host: { properties: { "attr.aria-checked": "this._checked", "attr.aria-expanded": "this.ariaExpanded", "attr.class": "this.btnClasses", "attr.role": "this._role", "attr.type": "this.type" } }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: ["\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MheButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'button[mhe-button]', changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>\n", styles: ["/*# sourceMappingURL=mheButton.css.map */\n"] }]
        }], propDecorators: { _checked: [{
                type: HostBinding,
                args: ['attr.aria-checked']
            }], ariaExpanded: [{
                type: HostBinding,
                args: ['attr.aria-expanded']
            }, {
                type: Input
            }], btnClasses: [{
                type: HostBinding,
                args: ['attr.class']
            }], _role: [{
                type: HostBinding,
                args: ['attr.role']
            }], type: [{
                type: HostBinding,
                args: ['attr.type']
            }, {
                type: Input
            }], class: [{
                type: Input
            }], enableLight: [{
                type: Input
            }], purpose: [{
                type: Input
            }], checked: [{
                type: Input
            }] } });
